import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-background-50/20 rounded-lg">
                <i className="ri-flower-line text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-heading font-bold text-background-50">
                桃花视频
              </span>
            </div>
            <p className="text-sm text-background-50/70 leading-relaxed">
              桃花视频汇集香蕉视频、糖豆视频、小蓝视频、蓝莓视频等热门影视资源，提供高清免费在线观看，满足你的追剧需求。
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">影视分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link>
              </li>
              <li>
                <a href="/category/dianshiju" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">电视剧</a>
              </li>
              <li>
                <a href="/category/dianying" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">电影</a>
              </li>
            </ul>
          </div>

          {/* Hot Tags */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {['狂飙', '三体', '流浪地球', '满江红', '斗罗大陆', '国产剧', '科幻', '悬疑'].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs rounded-full bg-background-50/15 text-background-50/80 cursor-pointer hover:bg-background-50/25 transition-colors whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/60">
            &copy; {new Date().getFullYear()} 桃花视频 TaohuaVideo.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/60">
            <span className="cursor-pointer hover:text-background-50/80 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-background-50/80 transition-colors">用户协议</span>
            <span className="cursor-pointer hover:text-background-50/80 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}